import { useState } from 'react';
import GoogleSSOLogin from './GoogleSSOLogin';
import "./AdminLogin.css"

const AdminLogin = ({ setAuthenticated }) => {
  const [showEmailLogin, setShowEmailLogin] = useState(false);

  return (
    <div className="admin-login">
      <h2>Admin Portal</h2>
      
      <GoogleSSOLogin setAuthenticated={setAuthenticated} />
      
      <div className="login-divider">
        <span>OR</span>
      </div>
      
      {showEmailLogin ? (
        <EmailPasswordLogin setAuthenticated={setAuthenticated} />
      ) : (
        <button 
          onClick={() => setShowEmailLogin(true)}
          className="secondary-login-btn"
        >
          Login with Email
        </button>
      )}
    </div>
  );
};

export default AdminLogin;

const EmailPasswordLogin = ({ setAuthenticated }) => {
  // Your existing email/password login form
};